import { useQueryClient, useQuery } from '@tanstack/react-query';
import { ControllersService } from 'src/services/controllers/controllers.service';

type UseGetAllControllersArgs = {
  customerId?: string;
  siteId?: string;
};

export const useGetAllControllersQuery = ({ customerId, siteId }: UseGetAllControllersArgs) => {
  const queryClient = useQueryClient();

  const isEnabled = !!customerId && !!siteId;
  const queryKey = isEnabled
    ? ['controllers', `${customerId}-${siteId}`]
    : ['controllers', 'empty'];

  const {
    data: controllers,
    isLoading,
    isError,
  } = useQuery({
    queryKey,
    queryFn: () => ControllersService.getAll(customerId as string, siteId as string),
    staleTime: 1000 * 60 * 2, // 2 min cache
    enabled: isEnabled,
    placeholderData: () => queryClient.getQueryData(queryKey),
  });

  return { controllers, isLoading, isError };
};
